import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';
import api, { errMsg } from '../../lib/api';

export const ReferralSourcesDialog = ({ open, sources, onClose, onSaved }) => {
  const [text, setText] = useState('');
  const save = async () => {
    try {
      const r = await api.put('/ludo/referral-sources', { sources: text.split('\n') });
      toast.success('Referral sources saved'); onSaved(r.data.sources);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (o) setText((sources || []).join('\n')); else onClose(); }}>
      <DialogContent data-testid="ludo-referral-dialog" onOpenAutoFocus={() => setText((sources || []).join('\n'))}>
        <DialogHeader><DialogTitle className="font-serif">Referral sources</DialogTitle></DialogHeader>
        <p className="text-[12px] text-[#6E5F78]">One per line. These appear in the client card's referral dropdown.</p>
        <Textarea rows={10} value={text} onChange={(e) => setText(e.target.value)} data-testid="ludo-referral-textarea" />
        <Button onClick={save} className="rounded-xl bg-[#5E5068] text-white" data-testid="ludo-referral-save">Save list</Button>
      </DialogContent>
    </Dialog>
  );
};

export default ReferralSourcesDialog;
